import { CONTENT_TYPE } from './utils';

// parseAt :: String -> [{node}, {node}...]
// eslint-disable-next-line
// @ts-ignore
function parseAt(val) {
    // 最终需要返回的ast
    const finalAst = [];

    // 涉及@解析的特殊字符
    const atContentStartChar = '@';
    const userIdFirstChar = '(';
    const userIdSecondChar = 'O';
    const userIdEndChar = ')';

    let stack = [];
    // 当前解析@的阶段
    let curAtPhase = -1;
    // 解析@涉及的所有阶段
    // AT_PHASE_MAP = {
    //     [atContentStartChar]: 0,
    //     [userIdFirstChar]: 1,
    //     [userIdSecondChar]: 2,
    //     [userIdEndChar]: 3
    // };

    // for most cases
    if ([atContentStartChar, userIdFirstChar, userIdSecondChar, userIdEndChar].some(char => !val.includes(char))) {
        return [
            {
                type: 'plainText',
                value: val,
            },
        ];
    }

    for (let i = 0; i < val.length; i++) {
        const curChar = val[i];
        switch (curChar) {
            /**
             * 根据当前的字符是否是@相关的特性字符做解析
             * 从phase 2 1 0 的顺序进行处理stack的信息
             * parse fail后 按照phase进行降级解析阶段 并相应处理stack数据
             */
            case atContentStartChar:
                if (curAtPhase === 2 || curAtPhase === 1) {
                    stack.push(curChar);
                } else {
                    finalAst.push({
                        type: 'plainText',
                        value: stack.join(''),
                    });
                    stack = [curChar];
                }
                curAtPhase = 0;
                break;
            case userIdFirstChar:
                if (curAtPhase === 2 || curAtPhase === 1) {
                    stack.push(curChar);
                    curAtPhase = 0;
                } else if (curAtPhase === 0) {
                    stack.push(curChar);
                    if (stack.join('') !== atContentStartChar) {
                        curAtPhase = 1;
                    }
                } else {
                    stack.push(curChar);
                }
                break;
            case userIdSecondChar:
                if (curAtPhase === 2) {
                    stack.push(curChar);
                    curAtPhase = 0;
                } else if (curAtPhase === 1) {
                    stack.push(curChar);
                    curAtPhase = 2;
                } else {
                    stack.push(curChar);
                }
                break;
            case userIdEndChar:
                if (curAtPhase === 2) {
                    if (stack[stack.length - 1] !== userIdSecondChar) {
                        // generate at AST node
                        const splited = stack.join('').split(userIdFirstChar);
                        finalAst.push({
                            type: 'at',
                            value: {
                                userId: splited[1].slice(1),
                                content: splited[0],
                            },
                        });
                        stack.length = 0;
                        curAtPhase = -1;
                    } else {
                        stack.push(curChar);
                        curAtPhase = 0;
                    }
                } else if (curAtPhase === 1) {
                    stack.push(curChar);
                    curAtPhase = 0;
                } else {
                    stack.push(curChar);
                }
                break;
            default:
                if (curAtPhase === 2) {
                    if (isNaN(curAtPhase)) {
                        curAtPhase = 0;
                    }
                } else if (curAtPhase === 1) {
                    // 这块如果有O已经在上面处理了 所以这块一定是parseFail
                    curAtPhase = 0;
                }
                stack.push(curChar);
        }
    }
    finalAst.push({
        type: 'plainText',
        value: stack.join(''),
    });
    return finalAst;
}

// TODO: 几个process可以提出来的
// eslint-disable-next-line
// @ts-ignore
export function processAt(contentAst) {
    // eslint-disable-next-line
    // @ts-ignore
    return contentAst.reduce((result, node) => {
        if (node.type === CONTENT_TYPE.PLAIN_TEXT) {
            return result.concat(parseAt(node.value));
        }

        return result.concat([node]);
    }, []);
}
